export const cleanLogoUrl = (url) => {
    if (!url) return url;
    return url.replace('c_fill,g_center,h_512,w_512', 'c_limit,h_512,w_1024')
              .replace('b_transparent,c_pad,h_512,w_512', 'c_limit,h_512,w_1024');
};
